import * as types from '../actiontypes';
import Env from '../../util/env';
import {serviceURL} from '../../util/uiconstants';

export const getAllAssociatedRisksSummary = (engagementId) => {
	const queryParameters = 'risks,risks.assertions,risks.assertions.account,risks.riskfactors';
	const endpointURL = Env.getBaseURL(serviceURL, engagementId) + 'RiskTypes?isActive=true&expand=' + queryParameters;

	return {
		type: types.GET_ALL_ASSOCIATED_RISKS_SUMMARY,
		meta: {
			api: {
				url: endpointURL,
				method: 'GET'
			}
		}
	};
};
